<template>
<div class="antialiased">
    <Sidebar />

    <div class="page">
        <Header hint="Cari" :enabled="false" />

        <div class="content">
            <div class="container">
                <!-- Page title -->
                <div class="page-header">
                    <div class="row d-flex justify-content-between">
                        <div class="col-auto">
                            <h2 class="page-title">Laporan Sales To Trade</h2>
                        </div>
                        <div class="col-auto">
                            <div class="row">
                                <div class="col-auto px-0"></div>
                                <div class="col-auto">
                                    <button class="btn btn-white" v-html="ic('filter') + ' Filter'" @click="_filter"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alert alert-info">
                    <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat data Sales
                    To Trade
                </div>
                <Skeleton type="table" :length="9" class="mt-3 bg-white" style="border: none" v-if="loading" />
                <Nodata v-if="!loading && data.length == 0 && isFilter" />
                <div class="text-center my-6" v-if="!loading && data.length > 0">
                    <img :src="asset('doc.png')" alt="" style="width: 200px; opacity: 0.5" @click="
                isFilter = false;
                data = [];
                _load();
              " />
                    <h3 class="my-3" v-html="data.length + ' Data'"></h3>

                    <div class="btn-group">
                        <button class="btn btn-outline-primary" @click="_createPdf">
                            Export PDF
                        </button>
                        <button class="btn btn-primary" @click="createExcelLite()">
                            Export Excel
                        </button>
                        <button class="btn btn-info" @click="formatPajak()">
                            Export Excel Pajak
                        </button>
                        <a :href="
                  'data:text/json;charset=utf-8,' +
                  encodeURIComponent(JSON.stringify(this.data))
                " class="btn btn btn-outline-primary" :download="
                  'laporan-stt' +
                  dataFilter.start_date +
                  ' - ' +
                  dataFilter.end_date +
                  '.json'
                ">
                            Export JSON
                        </a>
                    </div>
                </div>
                <div style="margin-bottom: 10px" v-if="!isFilter">
                    <span>
                        <input type="date" style="
                  margin-right: 5px;
                  border: none;
                  padding: 3px;
                  padding-left: 10px;
                  opacity: 0.8;
                  height: 24px;
                  font-size: 12px;
                  box-shadow: rgba(156, 156, 156, 0.02) 0px 1px 3px 0px,
                    rgba(162, 163, 163, 0.15) 0px 0px 0px 1px;
                  border-radius: 3px;
                " @change="_load()" v-model="navigationFilter.today" />
                    </span>
                    <button class="btn btn-sm btn-secondary" :disabled="i + 1 != navigation.length || !changed" @click="_changeLoaded(i)" style="margin-right: 5px" v-for="(row, i) in navigation" :key="i">
                        {{ row }} &nbsp;<i class="fa fa-times"></i>
                    </button>
                    <button class="btn btn-sm btn-danger" style="opacity: 0.8" @click="navigationFilter.status = ''">
                        Reset
                    </button>
                </div>
                <transition name="bounce" v-if="!isFilter">
                    <div class="row" v-if="load.data_cop && changed">
                        <div class="col card-sum" v-for="(cop, i) in load.data_cop" :key="i">
                            <span>Total {{ cop.status }}</span>
                            <div class="row">
                                <div class="col-6 card-detail">
                                    {{
                      _kiloFormat(
                        load.data_status[cop.status]
                          ? load.data_status[cop.status].grand_total_today
                          : 0
                      )
                    }}
                                    <br />
                                </div>
                                <div class="col-6" style="text-align: right">
                                    <div :class="
                        cop == ''
                          ? 'btn btn-detail'
                          : 'btn btn-' + cop.style + ' btn-detail'
                      " @click="navigationFilter.status = cop.status">
                                        {{
                        load.data_status[cop.status]
                          ? load.data_status[cop.status].percentage_growth
                          : 0 | currency
                      }}%
                                    </div>
                                </div>
                                <div>
                                    <span class="btn btn-sm btn-detail btn-secondary">{{
                        load.data_status[cop.status]
                          ? load.data_status[cop.status].qty_today
                          : 0 | currency
                      }}
                                        Krt</span>
                                    <span class="btn btn-sm btn-detail btn-primary" style="margin-left: 5px">
                                        {{
                        Math.round(
                          ((load.data_status[cop.status]
                            ? load.data_status[cop.status].grand_total_today
                            : 0) /
                            load.data_total.grand_total_today) *
                            10000
                        ) / 100
                      }}
                                        %
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="row" style="margin-top: 10px" v-if="!isFilter && load.data_default.length > 0">
                    <transition name="bounce">
                        <div class="col-8" v-if="load.data_default && changed">
                            <div class="card-sum-side" style="max-height: 440px; margin-top: 10px; overflow-y: auto" v-if="!isFilter">
                                <div v-for="(row, i) in load.data_default" :key="i">
                                    <div class="card-sum-sub" @click="
                        _loadDetail(row.id_param, row.nama_param, row.status)
                      " :title="
                        row.nama_param +
                        ' ' +
                        Math.round(
                          (row.grand_total_today /
                            load.data_total.grand_total_today) *
                            10000
                        ) /
                          100 +
                        '%'
                      " v-if="
                        (navigationFilter.status == '' ||
                          row.status == navigationFilter.status) &&
                        row.grand_total_today > 0
                      ">
                                        <span class="btn btn-secondary btn-sm" style="margin-bottom: 5px; margin-right: 5px">{{ row.nama_param }}
                                            <span v-if="navigationFilter.status == ''" v-html="'&nbsp' + row.status" /></span>
                                        <span class="btn btn-primary btn-sm" style="margin-bottom: 5px; margin-right: 5px">Rp
                                            {{ ribuan(Math.round(row.grand_total_today)) }}</span>
                                        <div class="progress" style="height: 20px">
                                            <div class="
                            progress-bar
                            progress-bar-striped
                            progress-bar-animated
                          " :class="
                            row.status == 'waiting'
                              ? 'bg-warning'
                              : row.status == 'approved'
                              ? 'bg-success'
                              : row.status == 'closed'
                              ? 'bg-danger'
                              : 'bg-info'
                          " role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" :style="{
                            width:
                              (row.grand_total_today /
                                load.data_total.grand_total_today) *
                                100 +
                              '%',
                          }">
                                                {{
                            Math.round(
                              (row.grand_total_today /
                                load.data_total.grand_total_today) *
                                100
                            ) + "%"
                          }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <transition name="bounce">
                        <div class="col card-sum" style="max-height: 440px; overflow-y: auto" v-if="load.data_detail && changed">
                            <div class="card-sum-sub" v-for="(row, i) in load.data_detail" :key="i">
                                <div class="row" @click="_loadDetail(row.id_param, row.nama_param)">
                                    <div class="col-8" style="margin-bottom: 10px">
                                        <div class="text-big">
                                            {{ ucwords(row.nama_param.toLowerCase()) }}
                                        </div>
                                        <button class="btn btn-sm btn-secondary" style="margin-right: 3px">
                                            Grand Total : Rp {{ row.grand_total_today | currency }}
                                        </button>
                                        <button class="btn btn-sm btn-secondary" style="margin-right: 3px">
                                            Qty : {{ row.qty_today | currency }} Krt
                                        </button>
                                        <button class="btn btn-sm" :class="
                          row.percentage_growth < 1
                            ? 'btn-danger'
                            : row.percentage_growth < 40
                            ? 'btn-warning'
                            : row.percentage_growth < 70
                            ? 'btn-success'
                            : 'btn-info'
                        ">
                                            Growth :
                                            {{
                          (row.grand_total_today - row.grand_total_yesterday)
                            | currency
                        }}
                                            /
                                            {{ (row.qty_today - row.qty_yesterday) | currency }} Krt
                                        </button>
                                    </div>
                                    <div class="col" style="text-align: right; margin-top: 10px">
                                        <b>{{ Math.round(row.percentage_growth) }}%</b>
                                    </div>
                                </div>
                                <div class="progress">
                                    <div :class="
                        row.percentage_growth < 1
                          ? 'progress-bar bg-danger'
                          : row.percentage_growth < 40
                          ? 'progress-bar bg-warning'
                          : row.percentage_growth < 70
                          ? 'progress-bar bg-success'
                          : 'progress-bar bg-info'
                      " role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" :style="{ width: Math.abs(row.percentage_growth) + '%' }"></div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>

                <transition>
                    <div style="
                font-size: 20px;
                opacity: 0.3;
                text-algin: center;
                width: 100%;
              " v-if="changedNote">
                        <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                        Mohon Menunggu memproses data ...
                    </div>
                </transition>
            </div>
        </div>
    </div>

    <FormFilter :config.sync="filter.config" :initData="filter.data" :dismiss.sync="filter.dismiss" :isSubmit.sync="filter.isSubmit" @submit="filter.action" />
</div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";

import jsPDF from "jspdf";
import "jspdf-autotable";
import retur from "../../../../store/retur";

export default {
    name: "LaporanSTT",
    components: {
        FormFilter
    },

    data() {
        return {
            auth: {},
            filter: {
                config: {
                    view: false,
                    title: null
                },
                data: null,
                isSubmit: false,
                action: () => {},
            },

            loading: false,
            isFilter: false,
            changed: true,
            changedNote: false,
            navigation: [],
            navigationFilter: {
                today: helper.methods.dateTime("ymd"),
                status: "",
            },
            data: [],
            dataFaktur : [],
            load: [],
            loaded: [
                [],
                [],
                [],
                []
            ],
            dataStr: "",

            dataFilter: {
                id_perusahaan: "",
                id_principal: [],
                id_salesman: "all",
                start_date: this.dateTime("ymd"),
                end_date: this.dateTime("ymd"),
                status: "all",
                depo: [],
            },
        };
    },

    mixins: [helper],

    methods: {
        _kiloFormat(num) {
            if (parseFloat(num) > 100000) {
                return this.ribuan(Math.round(parseFloat(num) / 1000)) + " K";
            }
            return this.ribuan(Math.round(num));
        },

        _get() {
            this.loading = true;

            this.axios
                .get("testing/stt", {
                    params: this.dataFilter
                })
                .then((res) => {
                    this.loading = false;

                    this.data = [];

                    if (res.data.length != 0) {
                        this.data = res.data.data;
                        this.dataFaktur = res.data.dataFaktur;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.onError(err);
                });
        },

        _setLoaded(data, param = "") {
            switch (param) {
                case "brand":
                    this.loaded[1] = data;
                    break;
                case "barang":
                    this.loaded[2] = data;
                    break;
                case "penjualan":
                    this.loaded[3] = data;
                    break;
                default:
                    this.loaded[0] = data;
                    break;
            }
        },

        _changeLoaded(param) {
            this.changed = false;
            this.load = this.loaded[param];
            this.navigation.splice(param, 1);
            console.log(this.load.group_by);
            this.navigationFilter["nama_" + this.load.group_by] = "";
            this.navigationFilter["id_" + this.load.group_by] = "";
            this.navigationFilter.status = "";
            setTimeout(() => {
                this.changed = true;
            }, 100);
        },

        _loadDetail(id_param, nama_param, status = "") {
            this.navigationFilter.status = status;
            if (this.load.group_by == "penjualan") return;
            this.changed = false;
            var limitLoading = setTimeout(() => {
                this.changedNote = true;
            }, 1000);
            this.navigationFilter["nama_" + this.load.group_by] = nama_param;
            this.navigationFilter["id_" + this.load.group_by] = id_param;
            this.navigation.push(nama_param);
            this.axios
                .get("testing/stt/monitoring", {
                    params: this.navigationFilter
                })
                .then((res) => {
                    this.load = res.data;
                    clearTimeout(limitLoading);
                    this.changedNote = false;
                    this._setLoaded(res.data, this.load.group_by);
                    setTimeout(() => {
                        this.changed = true;
                    }, 100);
                })
                .catch((err) => {
                    this.onError(err);
                    clearTimeout(limitLoading);
                });
        },

        _load() {
            this.axios
                .get("testing/stt/monitoring", {
                    params: {
                        today: this.navigationFilter.today,
                        status: "",
                    },
                })
                .then((res) => {
                    this.load = res.data;
                    this.navigation = [];
                    this._setLoaded(res.data);
                })
                .catch((err) => {
                    this.onError(err);
                });
        },

        _filter() {
            this.filter.config = {
                view: true,
                title: "Filter"
            };
            this.filter.action = (formData) => {
                this.isFilter = true;
                for (const key in formData) {
                    this.dataFilter[key] = formData[key];
                }
                this._get();
            };
        },

        createExcelLite() {
            this.createExcel({
                    data: this.data,
                    filename: "laporan-stt-lite" +
                        this.dataFilter.start_date +
                        " - " +
                        this.dataFilter.end_date,
                },
                false
            );
        },

        formatPajak() {
            let data = this.dataFaktur;
            let dataExcel = [];
            for (const penjualan in data) {
                if (Object.hasOwnProperty.call(data, penjualan)) {
                    let element = data[penjualan];
                    console.log(element.details)
                    let details = element.details
                    let discount = element.discount
                    let discount_after_tax = element.discount_after_tax
                    let subtotal = element.subtotal
                    for (const detail in details) {
                      if (Object.hasOwnProperty.call(details, detail)) {
                        let row = details[detail];
                        row['diskon_extra'] = (row.subtotal / subtotal) * discount
                        row['diskon_extra_tax'] = (row.subtotal / subtotal) * discount_after_tax
                        row['diskon'] += row['diskon_extra']
                        row['subtotal'] -= row['diskon_extra']
                        row['total'] -= row['diskon_extra_tax']
                        if(row.subtotal == 0){
                          row['subtotal'] = row['subtotal_net']
                          row['total'] = row['total_net']
                        }
                        row['ppn'] = row['total'] - row['subtotal']
                        dataExcel.push(row)
                      }
                    }
                }
            }
            console.log(dataExcel)
            this.createExcel({
                    data: dataExcel,
                    filename: "laporan-stt-pajak-lite" +
                        this.dataFilter.start_date +
                        " - " +
                        this.dataFilter.end_date,
                },
                false
            );
        },

        _createPdf() {
            let doc = new jsPDF("p"),
                user = JSON.parse(localStorage.user);
            let styles = {
                fillColor: [255, 255, 255],
                cellPadding: 0,
                lineColor: 0
            };

            // title
            doc.autoTable(this.pdfHeader(""));

            let header = [
                    ["Kode", "Nama Barang", "Dus/Pcs", "Sub Total", "Disc", "Ppn", "Net"],
                ],
                temp = [];

            for (let i = 0; i < this.data.length; i++) {
                let data = this.data[i];

                temp.push(data.scode);
                temp.push(data.segmen);
                temp.push(data.qtydus + "/" + data.qtypcs);
                temp.push(this.ribuan(data.subtotal + "|,2"));
                temp.push(this.ribuan(data.diskon + "|,2"));
                temp.push(this.ribuan(data.ppn + "|,2"));
                temp.push(this.ribuan(data.harga_net + "|,2"));

                header.push(temp);
                temp = [];
            }

            styles["cellPadding"] = 2;

            doc.autoTable({
                // body
                theme: "grid",
                styles: styles,
                margin: {
                    top: 10,
                    left: 10,
                    right: 10
                },
                body: header,
            });

            this.pdfDownload([doc.output()]);
        },
    },

    mounted() {
        this.auth = JSON.parse(localStorage.user);
        this._load();
        // this._get()
    },
};
</script>
<style lang="scss" scoped src="./laporan-sales-to-trade.scss"/>
